<template>
  <v-dialog
    v-model="dialog"
    :max-width="options.width"
    :style="{ zIndex: options.zIndex }"
    @keydown.esc="cancel"
    aria-labelledby="dialogTitle"
    aria-describedby="dialogMessage"
  >
    <v-card ref="dialogCard">
      <v-toolbar dense flat>
        <v-toolbar-title id="dialogTitle" class="black--text">{{ title }}</v-toolbar-title>
      </v-toolbar>
        <!-- <v-card-title class="public-blue white--text">{{ title }}</v-card-title> -->
      <v-card-text v-show="!!message" class="text--primary pa-4" id="dialogMessage">
        <span v-html="message"></span>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer class="hidden-xs-only"></v-spacer>
        <v-btn ref="okButton" color="public-blue" class="public-blue white--text" text @click.native="agree">{{ siteText.ui.okButton }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "AlertDialog",
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: {
        color: "public-blue",
        width: 500,
        zIndex: 200
      }
    };
  },
  computed: {
    ...mapGetters(['siteText']),
  },
  methods: {
    open(title, message, options) {
      this.dialog = true;
      this.title = title;
      this.message = message;
      this.options = Object.assign(this.options, options);
      
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    }
  }
};
</script>
